import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import { requirementTemplateApi } from '../api';
import { createErrorToast, createSuccessToast, createToast } from '../redux/modules/app';
import { queryClient } from '../utils/queryClientUtil';

import requirementTemplateKeys from './models/requirementTemplates/keys';
import { camelCaseApiResponse, deleteInfiniteListsItem, getPageData, modifyInfiniteListsItem } from './util';

/* QUERIES
========================================================= */

export const useRequirementTemplateData = (templateId, options = {}) => useQuery(
  requirementTemplateKeys.template(templateId),
  () => camelCaseApiResponse(() => requirementTemplateApi.getRequirementTemplate(templateId)),
  options
);

export const useRequirementTemplateFolderData = ({
  companyId,
  pageSize = 25,
  options = {}
}) => useInfiniteQuery(
  requirementTemplateKeys.companyFolders(companyId),
  ({ pageParam = 1 }) => camelCaseApiResponse(() => requirementTemplateApi.listRequirementTemplateFolders(
    companyId,
    { page: pageParam, pageSize }
  )),
  {
    ...options,
    getNextPageParam: getPageData
  }
);

export const useRequirementTemplatesData = ({
  companyId,
  folderId,
  filter,
  sort,
  pageSize = 25,
  options = {}
}) => useInfiniteQuery(
  requirementTemplateKeys.companyFolderTemplates(companyId, folderId, { filter, sort }),
  ({ pageParam = 1 }) => camelCaseApiResponse(() => requirementTemplateApi.listRequirementTemplates(
    companyId,
    { page: pageParam, pageSize },
    filter,
    sort
  )),
  {
    ...options,
    getNextPageParam: getPageData
  }
);

